import { render, staticRenderFns } from "./SliderArrowsComponent.vue?vue&type=template&id=2d159298"
import script from "./SliderArrowsComponent.vue?vue&type=script&lang=js"
export * from "./SliderArrowsComponent.vue?vue&type=script&lang=js"
import style0 from "./SliderArrowsComponent.vue?vue&type=style&index=0&id=2d159298&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d159298')) {
      api.createRecord('2d159298', component.options)
    } else {
      api.reload('2d159298', component.options)
    }
    module.hot.accept("./SliderArrowsComponent.vue?vue&type=template&id=2d159298", function () {
      api.rerender('2d159298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/slider/SliderArrowsComponent.vue"
export default component.exports